// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"8a890750","399":"5101c0c4","490":"23dd2f92","565":"a17082b3"}[chunkId] + ".chunk.css";
};